import React, { useMemo } from "react"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useApiQuery } from "../../../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../../../merchants/merchantHooks"
import { CreateOrEditPriceListFormValues } from "../../../priceListTypes"
import { MenuItem } from "@mui/material"
import { FormikDropdown } from "../../../../../../../shared/components/forms/Formik"
import { fetchMerchantVatCodes, VatCodesQuery } from "../../../../vatCodes/vatCodesApi"

export function SelectVatCode() {
    const { merchantId } = useMerchant()

    const vatCodesResult = useApiQuery(fetchMerchantVatCodes, {
        queryName: VatCodesQuery.LIST,
        dependencies: {
            merchantId,
        },
        select: (data) => data.vatCodes,
    })

    const data = useMemo(() => vatCodesResult.data ?? [], [vatCodesResult.data])

    return (
        <LocalizedStrict id="create-or-edit-price-list-field-vat-code" attrs={{ label: true }}>
            <FormikDropdown<CreateOrEditPriceListFormValues> fullWidth name="vatCodeId" label="Vat code">
                {data.map((vatCode) => (
                    <MenuItem key={vatCode.id} value={vatCode.id}>
                        {vatCode.name}
                    </MenuItem>
                ))}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
